import React, { Component, Fragment } from "react";
import { withGetScreen } from "react-getscreen";
import { Alert } from "@maxmilhas/hangar-components-atomic";

import { isMobile } from "../../../../../../js/components/searchform/utils/common";
import { addDecimalPoints, formatCurrency } from "../../../../../../js/shared/utils";
import Loading from "../../../../../shared/Loading/Loading";
import Modal from "../../../../../shared/Modal/Modal";
import { saleFlightChangeNotify, saleInconsistency } from "../../../../shared/requests-api";
import { formatDateToPortugueseFormat } from "../../../../shared/utils";
import SaleDetailsFlightPanel from "../../../sale-details/SaleDetailsFlightPanel";
import SaleDetailsInconsistencyModal from "../../../sale-details/SaleDetailsInconsistencyModal";
import { MODALITY, STATUS } from "../../consts";
import { Tooltip } from "react-tippy";
import { capitalize, getStatus, isForwardPayment, isFrozenPayment, isResale } from "../../helpers";
import CardTag from "../../../atoms/card-tag";

class ItemListFidelityPlan extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalInconsistencyOpen: false,
			modalConfirmFlightNotify: false,
			loading: false,
			modalLoading: false,
			showSucesso: false
		};
	}
	modalInconsistencyHandlerFn(isOpen = false) {
		this.setState({
			modalInconsistencyOpen: isOpen
		});
	}
	flightNotifyFn(e) {
		this.setState({
			modalConfirmFlightNotify: true
		});
	}

	onConfirmFn(e) {
		e.preventDefault();
		this.loadingHandler();
		this.onCancelFn(e);
		saleFlightChangeNotify(this.props.details.id)
			.then(response => {
				console.log(response);

				this.loadingHandler();
				this.setState({
					modalConfirmFlightNotify: false
				});
				this.props.onConfirm(e);
			})
			.catch(err => {
				console.log(err);

				this.loadingHandler();
				this.setState({
					modalConfirmFlightNotify: false
				});
			});
	}

	loadingHandler() {
		this.setState({
			loading: !this.state.loading
		});
	}

	onCancelFn(e) {
		e.preventDefault();
		this.setState({
			modalConfirmFlightNotify: false
		});
	}

	modalInconsistencyConfirm(text) {
		this.setState({
			modalLoading: true
		});
		saleInconsistency({
			idSale: this.props.sale.id,
			idTransaction: this.props.sale.transaction,
			inconsistency: text
		})
			.then(response => {
				this.setState({
					modalLoading: false,
					showSucesso: true
				});
				this.modalInconsistencyHandlerFn();
			})
			.catch(err => {
				console.log("err", err);
				this.setState({
					modalLoading: false
				});
			});
	}

	render() {
		const isModalityScheduled = this.props.sale.modality === MODALITY.SCHEDULED;
		const showCollapse = !isForwardPayment(this.props.sale.modality, this.props.sale.transaction);
		const paymentReceived = this.props.sale.forwardPaymentStatus === STATUS.RECEIVED;
		const frozenPayment = isFrozenPayment(this.props.sale.status);
		const showPaymentSchedule = [
			STATUS.TO_BE_RECEIVED,
			STATUS.BANK_DATA_DIVERGENCE,
			STATUS.ANALYSIS
		].includes(this.props.sale.status);

		const getTagTitle = () => {
			if (this.props.sale.reuseMiles) {
				return 'Reutilização de milhas';
			} else if (isModalityScheduled) {
				return 'Agendado';
			} else {
				return 'Convencional';
			}
		}
		return (
			<Fragment>
				<div
					className={`item-list-fidelity-plan col-xs-16
						${this.props.open ? "item-list-fidelity-plan__open-card" : ""}
						${getStatus(this.props.sale.status)}
					`}
				>
					<div className="item-list-fidelity-plan__card">
						<div
							className={`item-list-fidelity-plan__block 
								${getStatus(this.props.sale.status)}
							`}
						>
							<CardTag show color={`card-tag-custom ${isModalityScheduled ? 'scheduled' : 'conventional'} `}>
								{getTagTitle()}
							</CardTag>
							{frozenPayment && (
								<Alert
									icon="icon-max-communication-doubt"
									className="payment-guarantee-style payment-suspended"
								>
									O pagamento desta venda está congelado devido ao processo de Recuperação Judicial.
									Liberaremos após plano de ação aprovado e executado.
								</Alert>
							)}
							<ul
								className="item-list-fidelity-plan__block--ul"
								style={{ opacity: !!this.state.loading || !!this.props.loading ? "0.4" : "1" }}
							>
								<li className="item-list-fidelity-plan__block--li has-border children-1">
									Transação:
									<span>{this.props.sale.transaction}</span>
								</li>
								<li className="item-list-fidelity-plan__block--li has-border children-2">
									Localizador: <span>{this.props.sale.localizator}</span>
								</li>
								<li className="item-list-fidelity-plan__block--li has-border children-3">
									Venda: <span>{formatDateToPortugueseFormat(this.props.sale.saleDate)}</span>
								</li>
								<li className="item-list-fidelity-plan__block--li has-border children-4">
									Taxa de embarque:
									<span>
										{this.props.sale.feeBoarding == 0
											? "Paga pela MaxMilhas"
											: formatCurrency(this.props.sale.feeBoarding)}
									</span>
								</li>

								<li className={`item-list-fidelity-plan__block--li has-border children-4`}>
									Taxa de bagagem:
									<span>
										{this.props.sale.feeLuggage == 0
											? "Paga pela MaxMilhas"
											: formatCurrency(this.props.sale.feeLuggage)}
									</span>
								</li>

								<li className={`item-list-fidelity-plan__block--li children-1`}>
									{addDecimalPoints(this.props.sale.miles)} milhas:
									<span>
										{!!this.props.sale.outgoings?.result?.length
											? formatCurrency(this.props.sale.total)
											: formatCurrency(this.props.sale.totalToRecive)}
									</span>
								</li>
								<li className={`item-list-fidelity-plan__block--li children-2`}>
									1.000 milhas: <span>{formatCurrency(this.props.sale.price)}</span>
								</li>
								{!isResale(this.props.sale.status) && (
									<li className={`item-list-fidelity-plan__block--li children-3`}>
										Pagamento: {frozenPayment ? (
											<span>A definir</span>
										) : (
											<span>
												{!!this.props.sale.outgoings?.result?.length
													? `${this.props.sale.outgoings?.result?.length} parcelas `
													: formatDateToPortugueseFormat(this.props.sale.paymentDate)}{" "}
												{showPaymentSchedule && (
													<Tooltip
														title="Esse pagamento pode ser efetuado até as 21h da data programada"
														tabIndex="0"
														theme="light"
														position="top"
														arrow
													>
														<i className="icon-clock" />
													</Tooltip>
												)}
											</span>
										)}
									</li>
								)}
								<li className={`item-list-fidelity-plan__block--li children-3`}>
									Status:
									<span>
										{isModalityScheduled ?
											paymentReceived ? `Recebido na negociação de ID ${this.props.sale.negotiationId ?? ""}` : `A receber na negociação de ID ${this.props.sale.negotiationId ?? ""}`
											: capitalize(getStatus(this.props.sale.status, true))
										}
									</span>
								</li>
								<li className="item-list-fidelity-plan__block--li children-5">
									Prog. Fidelidade: <span>{this.props.sale.fidelityName}</span>
								</li>
								<li className="item-list-fidelity-plan__block--li children-5">
									Login Fidelidade: <span>{this.props.sale.fidelityLogin}</span>
								</li>
								{!!this.props.sale.bonus && (
									<li className={`item-list-fidelity-plan__block--li children-5`}>
										Bonus: <span>{formatCurrency(this.props.sale.bonus)}</span>
									</li>
								)}
							</ul>
						</div>

						{showCollapse && (
							<div className="item-list-fidelity-plan__details-button">
								<button
									className="btn btn-icon"
									onClick={e => this.props.click(e, this.props.sale.id, this.props.sale.status)}
									data-action="item-list-fidelity-plan-expand-collapse"
								>
									<i className={this.props.open ? "icon-arrow-up" : "icon-arrow-down"} />
								</button>
							</div>
						)}
					</div>
					{showCollapse && (
						<div
							className="sale-details-flight-panel"
							style={{ maxHeight: !!this.props.open ? "1000px" : "0px" }}
						>
							{!!this.props.open && (
								<SaleDetailsFlightPanel
									clickInconsistency={e => this.modalInconsistencyHandlerFn(e)}
									flightNotify={e => this.flightNotifyFn(e)}
									salesCanceled={this.props.sale.status === 3}
									salesResale={this.props.sale.status === 4}
									modality={this.props.sale.modality}
									item={this.props.details}
									flightButtonAllow={this.props.allowChangeFlightNotify}
								/>
							)}
						</div>
					)}
					{!!this.state.modalInconsistencyOpen && (
						<SaleDetailsInconsistencyModal
							close={e => this.modalInconsistencyHandlerFn(e)}
							confirm={e => this.modalInconsistencyConfirm(e)}
							loading={this.state.modalLoading}
						/>
					)}
					{(!!this.state.loading || !!this.props.loading) && <Loading />}

					{!!this.state.modalConfirmFlightNotify && (
						<Modal
							show={this.state.modalConfirmFlightNotify}
							cancel="Cancelar"
							confirm="Confirmar"
							title="Informar alteração do voo"
							fixed={isMobile()}
							description={
								<div>
									<p>
										<strong>Atenção!</strong>
									</p>
									<p>Deseja confirmar a alteração deste voo?</p>
									<p>Favor verificar se o localizador é {this.props.sale.localizator}</p>
								</div>
							}
							onConfirm={e => this.onConfirmFn(e)}
							onCancel={e => this.onCancelFn(e)}
						/>
					)}
				</div>

				<Modal
					title="DIVERGÊNCIA INFORMADA"
					description="Sua divergência foi informada com sucesso :)"
					confirm="Fechar"
					show={this.state.showSucesso}
					fixed={true}
					onCancel={() => this.setState({ showSucesso: false })}
					onConfirm={() => this.setState({ showSucesso: false })}
				/>
			</Fragment>
		);
	}
}
export default withGetScreen(ItemListFidelityPlan, {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
